<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{$vuetify.lang.t('$vuetify.auth.login.formTitle')}}</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid" ref="form" lazy-validation @keyup.native.enter="valid && login()">
              <v-switch
                      v-model="byPhone"
                      flat
                      :label="loginMethod"
              ></v-switch>
              <v-text-field
                      v-if="byPhone"
                      :label="$vuetify.lang.t('$vuetify.auth.login.userPhone')"
                      name="username"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="phone"
                      v-mask="'+7 (###) ###-##-##'"
                      :rules="[fieldValidationRules.required(vue)]"
              />
              <v-text-field
                      v-if="!byPhone"
                      :label="$vuetify.lang.t('$vuetify.auth.login.userName')"
                      name="username"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="email"
                      :rules="[fieldValidationRules.required(vue)]"
              />

              <v-text-field
                      id="password"
                      :label="$vuetify.lang.t('$vuetify.auth.login.password')"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="pass"
                      :rules="[fieldValidationRules.required(vue)]"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
<!--            <v-btn text color="primary" type="button" to="/registration">-->
<!--              {{ $vuetify.lang.t('$vuetify.auth.login.registrationBtn') }}-->
<!--            </v-btn>-->
            <v-spacer/>
            <v-btn color="primary" type="submit" @click="login" :loading="axiosLoading" :disabled="!valid">
              {{ $vuetify.lang.t('$vuetify.auth.login.loginBtn') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // @ is an alias to /src
  import {mask} from 'vue-the-mask'
  import {mapState} from 'vuex'

  export default {
    directives: {mask},
    name: 'Login',
    computed: {
      ...mapState(['barColor', 'barImage']),
      loginMethod(){
        return this.byPhone ? 'Вход по телефону' : 'Вход по email'
      }
    },
    data() {
      return {
        vue: this,
        valid: false,
        byPhone: false,
        email: null,
        phone: null,
        pass: null,
      }
    },
    methods: {
      login() {
        if (this.$refs.form.validate()) {
          let credentials = null
          if(this.byPhone) {
            credentials = {
              phone: this.phone.match(/\d/g).join(''),
              password: this.pass,
            }
          } else {
            credentials = {
              email: this.email,
              password: this.pass,
            }
          }

          this.$store.dispatch('login', credentials)
            .then(() => {
              this.$router.push(this.$route.query.redirect || '/')
            })
            .catch(err => console.log(err))
        }
      },
    },
  }
</script>
